import React from "react";
import useReveal from "../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Phone } from "lucide-react";

const items = [
  {
    q: "Wie vereinbare ich am schnellsten einen Termin?",
    a: "Am schnellsten erreichen Sie uns telefonisch unter 02131 544154. Wir klären Ihr Anliegen direkt und vereinbaren einen passenden Termin — meist schon innerhalb weniger Tage.",
  },
  {
    q: "Warten Sie alle Fahrzeugmarken?",
    a: "Ja. Als freie Meisterwerkstatt kümmern wir uns um alle gängigen Marken und Fahrzeugtypen — vom Kleinwagen bis zum Transporter.",
  },
  {
    q: "Kann ich TÜV und HU direkt bei Ihnen machen lassen?",
    a: "Ja, die Hauptuntersuchung (TÜV/HU) nehmen wir direkt in unserer Werkstatt ab. Auf Wunsch führen wir vorher eine Vorprüfung durch, damit Sie beim ersten Anlauf bestehen.",
  },
  {
    q: "Erhalte ich einen Kostenvoranschlag vor der Reparatur?",
    a: "Selbstverständlich — wir geben Ihnen vor jeder Reparatur einen schriftlichen Kostenvoranschlag. Wir besprechen den Umfang transparent, und ohne Ihre Zustimmung beginnen wir nicht mit der Arbeit.",
  },
  {
    q: "Wie lange dauert eine Inspektion?",
    a: "Das hängt davon ab, ob wir Ihr Fahrzeug bereits kennen. Aber unser Versprechen: Wenn Sie das Auto morgens bei uns abstellen, können Sie es abends wieder abholen — das funktioniert immer. Den genauen Zeitrahmen besprechen wir bei der Terminvereinbarung.",
  },
  {
    q: "Was, wenn unterwegs etwas Ungewöhnliches auftritt?",
    a: "Rufen Sie uns einfach an — wir beraten am Telefon, ob Sie weiterfahren können oder besser stehen bleiben sollten. Bei akuten Problemen versuchen wir, Sie kurzfristig einzuschieben.",
  },
];

export default function FAQ() {
  const [ref, visible] = useReveal();
  return (
    <section
      id="faq"
      ref={ref}
      data-testid="faq-section"
      className={`relative bg-[#09090b] border-t border-zinc-900 transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-24 md:py-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.4em] uppercase gold-text mb-4">
            — FAQ
          </div>
          <h2
            data-testid="faq-heading"
            className="font-display text-4xl md:text-6xl uppercase tracking-tight leading-[0.95]"
          >
            Kurze
            <br />
            Antworten.
            <br />
            <span className="gold-text">Ehrlich.</span>
          </h2>
          <p className="mt-6 text-zinc-400 text-sm leading-relaxed max-w-sm">
            Sie haben eine Frage, die hier nicht beantwortet wird? Rufen Sie uns
            einfach an — persönlich geht am schnellsten.
          </p>
          <a
            href="tel:02131544154"
            data-testid="faq-call"
            className="mt-8 inline-flex items-center gap-3 gold-bg text-black font-semibold px-6 py-4 text-xs tracking-[0.3em] uppercase transition-colors"
          >
            <Phone size={16} /> 02131 544154
          </a>
        </div>

        <div className="lg:col-span-7">
          <Accordion
            type="single"
            collapsible
            className="border border-zinc-800 bg-[#0f0f12]"
            data-testid="faq-accordion"
          >
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-zinc-800 last:border-b-0 px-6"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-base md:text-lg font-medium text-white hover:no-underline text-left data-[state=open]:gold-text">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 pr-6 text-sm text-zinc-300 leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
